import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IProjectSourcesClient, ProjectSourcesClient } from "app/ApiClient";
import { IState } from "slices";
import { LoadingState } from "types";

import { defaultProjectsSourcesState, ProjectSourcesState } from "./projectSourcesState";

const projectSourcesClient: IProjectSourcesClient = new ProjectSourcesClient(process.env.REACT_APP_API_URL);

export const getAllSources = createAsyncThunk("projectSources/getAll", async () => {
  const projectSources = await projectSourcesClient.getAll();
  return projectSources;
});

export const projectSourcesSlice = createSlice({
  name: "projects",
  initialState: defaultProjectsSourcesState,
  reducers: {
    resetProjectSources: (state) => {
      state.projectSourcesLoading = LoadingState.idle;
      state.projectSources = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllSources.fulfilled, (state, action) => {
      state.projectSources = action.payload;
    });

    builder.addCase(getAllSources.pending, (state) => {
      state.projectSourcesLoading = LoadingState.pending;
    });
    builder.addCase(getAllSources.rejected, (state) => {
      state.projectSourcesLoading = LoadingState.failed;
    });
  },
});
export const { resetProjectSources } = projectSourcesSlice.actions;

export const projectSourcesSelector = (state: IState): ProjectSourcesState => state.projectSources;

export default projectSourcesSlice.reducer;
